import React, { createContext, useContext, useRef, useCallback } from 'react';

const NavContext = createContext({
  isTransitioning: () => false,
  triggerTransition: () => {},
});

export const NavProvider = ({ children }) => {
  const lastTransitionRef = useRef(0);

  const triggerTransition = useCallback(() => {
    lastTransitionRef.current = Date.now();
  }, []);

  const isTransitioning = useCallback(() => {
    return Date.now() - lastTransitionRef.current < 400;
  }, []);

  return <NavContext.Provider value={{ isTransitioning, triggerTransition }}>{children}</NavContext.Provider>;
};

export const useNavContext = () => useContext(NavContext);

export default NavContext;
